// extracted by mini-css-extract-plugin
export default {"container":"UserFilterBar_container__3YFpr","filters":"UserFilterBar_filters__GWJtp","quickSearch":"UserFilterBar_quickSearch__ZrUGk"};